import React, { useContext, useState, ToastAndroid, useEffect } from "react";
import { getSelectedStoreChallanView, getStoreInvoicePrinter, getStoreLocalData, getStoreNormalA5A4Printer, getStorePOSEnabled, getStorePOSInvoicePrinterReceiptType, getStorePOSInvoicePrinterValue, getUserData, setSelectedStoreChallanView } from "../../../utils/localStorage";
import { useLocation, useNavigate } from "react-router-dom";
import StoreMenu from "../../StoreMenu";
import { getWareHouseStoreChallanQrCode, getWareHouseStoreChallanQrCodeNewReceipt } from "../../../services/ChallanApi/Challan";
import { getStoreWarehouseInfoByWarehouse } from "../../../services/warehouse/StoreWarehouse";
import { Button } from "primereact/button";

import qz from "qz-tray";
import { localeDateEndDate, localeDateStartDate } from "../../../constants/DateUtil/DateUtil";
import { STORE_BASE_URL } from "../../../services/BaseURL";

const WarehouseChallanReceipt = () => {
  const { brandProfileData, userProfileData, warehouseData } = getUserData();

  let brand = brandProfileData;
  const userProfile = userProfileData;
  let warehouseId = warehouseData.id;

  const { storeLocalData } = getStoreLocalData();
  

  const location = useLocation();
  const { challanData } = location.state || {}; // Fallback to prevent undefined errors

  const [storeChallanInfoData, setStoreChallanInfoData] = useState([]);
  const [challanQrCodeData, setChallanQrCodeData] = useState([]);

    const [type, setType] = useState("");
    const [storePOSEnabledValue, setStorePOSEnabledValue] = useState("");
    const [invoicePrinterPOSValue, setInvoicePrinterPOSValue] = useState("");
    const [invoicePrinterReceiptType, setInvoicePrinterReceiptType] = useState("");
  
    const fetchStorePOSMachine = async () => {
          try {
            const selectedTagPrinterData = await getStorePOSEnabled();
      
            const value =
              selectedTagPrinterData?.storePOSEnabled === true ||
              selectedTagPrinterData?.storePOSEnabled === "true";
            
              if(value) {
                setType("mini")
              }
            setStorePOSEnabledValue(value);
          } catch {
            setStorePOSEnabledValue(false);
          }
        };
  

  const fetchStoreExternalWarehouseChallanQrcode = (id) => {
    getWareHouseStoreChallanQrCodeNewReceipt(id)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setStoreChallanInfoData(Res);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  };

  const [garmentSummary, setGarmentSummary] = useState([]);

  const [warehouseList, setWarehouseList] = useState([]);

   const fetchStorePOSReceiptType = async () => {
        try {
          const ReceiptType = await getStorePOSInvoicePrinterReceiptType();
    
          const value =
            ReceiptType?.invoicePrinterPOSReceiptTypeValue === true ||
            ReceiptType?.invoicePrinterPOSReceiptTypeValue === "true";
    
          if (value) {
            setType("mini")
          }
          setInvoicePrinterReceiptType(value);
        } catch {
          setInvoicePrinterReceiptType(false);
        }
      };

  const fetchChallanQrCodeList = (data) => {
    getWareHouseStoreChallanQrCode(data)
      .then((response) => {
        if (!response.data.error) {
          const Res = response.data;
          setChallanQrCodeData(Res);
          if (Res.length > 0) {

            getStoreWarehouseInfoByWarehouse(warehouseId).then((response) => {
              if (!response.data.error) {
                const WarehouseRes = response.data;
                // const warehouseData = Res.map((item) => ({
                //   id: item.id,
                //   name: item.store.storeName,
                // }));
                const warehouseCurrentStoreId = Res[0]?.wareHouseStoreChallan?.wareHouseStoreId;
                const newData = WarehouseRes.filter((item) => item.id === warehouseCurrentStoreId);
                setWarehouseList(newData);

              }
            });

            const garmentCount = Res.reduce((acc, curr) => {
              const garmentName = curr.qrCodeInfo.garmentName;

              // Check if garmentName exists in accumulator and increment count
              if (acc[garmentName]) {
                acc[garmentName] += 1;
              } else {
                acc[garmentName] = 1;
              }
              return acc;
            }, {});

            // Convert the accumulator object to an array of results
            const result = Object.keys(garmentCount).map((garmentName) => ({
              garmentName,
              count: garmentCount[garmentName],
            }));

            // You can update state with the result
            setGarmentSummary(result);
          }
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });

    
  };

  
     const fetchSelectedPOSInvoicePrinterValue = async () => {
            try {
              const invoicePrinterPOSValue = await getStorePOSInvoicePrinterValue();
              setInvoicePrinterPOSValue(invoicePrinterPOSValue?.invoicePrinterPOSValue || "");
            } catch {
              setInvoicePrinterPOSValue("");
            }
          };

  useEffect(() => {
    if (challanData) {
      const requestData = {
        startDate: localeDateStartDate(new Date(challanData.createdDate)),
        endDate: localeDateEndDate(new Date(challanData.createdDate)),
        wareHouseStoreIdIn: [challanData.wareHouseStoreId],
        challanTypeStatusIn: [challanData.challanTypeStatus],
        challanIdIn: [challanData.id],
        qrCodeStatusIn: [],
        recordType: "",
      };

      fetchChallanQrCodeList(requestData);
    }
  }, [challanData]);

  const [storeChallanView, setStoreChallanView] = useState(false);

  const handleEWHChallanViewChange = async (selectedType) => {
    setStoreChallanView(selectedType);
    await setSelectedStoreChallanView(selectedType);
  };

  const fetchSelectedEWHChallanView = async () => {
    try {
      const selectedEWHChallanTypeData = await getSelectedStoreChallanView();
      setStoreChallanView(selectedEWHChallanTypeData?.storeChallanView || "m1");
    } catch {
      setStoreChallanView("m1");
    }
  };

  useEffect(() => {
    fetchStorePOSMachine();
    fetchSelectedPOSInvoicePrinterValue()
    fetchStorePOSReceiptType();
    fetchStoreExternalWarehouseChallanQrcode(challanData.id);
    fetchSelectedEWHChallanView();
  }, []);

  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const data = {
    storeName: warehouseList[0]?.store?.storeName,
    brandName: brand.name,
    fullAddress: warehouseList[0]?.store?.address?.fullAddress,
    mobileNumber: warehouseList[0]?.store?.mobileNo,
    email: warehouseList[0]?.store?.email,
    gstNo: warehouseList[0]?.store?.gstNo,
    orderNo: challanQrCodeData.orderNo,
    billNo: challanQrCodeData.invoiceNo,

    customerName: challanQrCodeData.customerName,
    customerMobile: challanQrCodeData.customerMobile,
    customerAddress: challanQrCodeData.customerAddress,

    warehouseName:
      challanQrCodeData[0]?.wareHouseStoreChallan?.wareHouseStore?.wareHouse
        ?.name,
    warehouseNumber:
      challanQrCodeData[0]?.wareHouseStoreChallan?.wareHouseStore?.wareHouse
        ?.mobileNo,
    warehouseAddress:
      challanQrCodeData[0]?.wareHouseStoreChallan?.wareHouseStore?.wareHouse
        ?.address?.fullAddress,
    ChallanNumber: challanQrCodeData[0]?.wareHouseStoreChallan?.challanNumber,
    challanMode: challanQrCodeData[0]?.wareHouseStoreChallan?.challanTypeStatus,
    date: challanQrCodeData[0]?.wareHouseStoreChallan?.createdDate?.split(
      "T"
    )[0],
  };

  const orderItems2 = storeChallanInfoData.map((item) => ({
    ...item,
    itemMap: item.itemMap || [], // Ensure addOn is always an array
  }));

  const totalQuantity = garmentSummary.reduce(
    (sum, item) => sum + item.count,
    0
  );

  const [invoicePrinterValue, setInvoicePrinterValue] = useState("");
  const fetchSelectedInvoicePrinter = async () => {
    try {
      const selectedInvoicePrinterData = await getStoreInvoicePrinter();
      setInvoicePrinterValue(selectedInvoicePrinterData?.invoicePrinter || "");
    } catch {
      setInvoicePrinterValue("");
    }
  };

  const [normalA5A4PrinterValue, setNormalA5A4PrinterValue] = useState("");

  const fetchSelectedNormalA5A4Printer = async () => {
    try {
      const selectedNormalA5A4PrinterData = await getStoreNormalA5A4Printer();
      setNormalA5A4PrinterValue(
        selectedNormalA5A4PrinterData?.normalA5A4Printer || ""
      );
    } catch {
      setNormalA5A4PrinterValue("");
    }
  };


  const [isConnected, setIsConnected] = useState(false);

  useEffect(() => {
    if (!isConnected) {
      connectToQZ();
    }

    fetchSelectedInvoicePrinter();
    fetchSelectedNormalA5A4Printer();
  }, []);

  const connectToQZ = async () => {
    try {
      if (!qz.websocket.isActive()) {
        await qz.websocket.connect();
        setIsConnected(true);
      }
    } catch (err) {
      console.error("Connection error:", err);
    }
  };

  
    function printPOSImage() {
  
      // const payload = "https://api.bill.ind.in/bi/dev/di/1603261100071vt8SrBX";
      // const payload = STORE_BASE_URL + "/store/api/secure/v1/download-invoice/" + storeCustomerId + "/" + bookingOrderId + "/web"
      const payload = STORE_BASE_URL + "/warehouse/api/external/v1/challan/" + challanData.id + "/download/png"
      // https://dhobicart.in/warehouse/api/external/v1/challan/636/download/png
      const imgUrl = encodeURIComponent(payload);

      window.location.href =
        `bluprintlabelutility://share/open?type=imageUrl&data=${imgUrl}&scale=2&printer-id=${invoicePrinterPOSValue}&printer-type=${invoicePrinterReceiptType ? "RECEIPT_AC" : "RECEIPT_NC"}`;
    }

  const printChallanM1HTML = async () => {
    try {
      // const printer = await qz.printers.find("POS80 Printer"); // Adjust to your printer's actual name
      const printer = await qz.printers.find(invoicePrinterValue);
      const config = qz.configs.create(printer, {
        encoding: "UTF-8",
        size: { width: 3 },
        units: "in",
        density: "600",
        colorType: "grayscale",
      });

      const garmentSummaryHtml = garmentSummary
        .map((item, index) => {
          const mode = item.garmentName?.replace(/_/g, " ");
          const user = item.count;

          return `
          <div style="display: flex;">
            <p style="flex: 1; font-size: 12px; margin: 0; text-align: left;">${index + 1
            }</p>
            <p style="flex: 1; font-size: 12px; margin: 0; text-align: left;">${mode}</p>
            <p style="flex: 1; font-size: 12px; margin: 0; text-align: right;">${user}</p>
          </div>
        `;
        })
        .join("");

      const htmlContent = `
      <html>
        <body style="font-size: 12px; font-family: sans-serif;">
          <div style="text-align: center;">
            <span style="font-size: 18px; font-weight: bold;">Challan</span>
            <hr style="border-top: 1px dashed #000;"/>
            <p style="font-size: 14px; font-weight: bold; margin: 0;">${data.storeName
        }</p>
            <p style="font-size: 12px; margin: 0;">${data.fullAddress}</p>
            <p style="font-size: 12px; margin: 0;">${data.mobileNumber}</p>
            <p style="font-size: 12px; margin: 0;">${data.email}</p>
            ${
        data.gstNo
          ? `<p style="font-size: 12px; margin: 0;">${storeLocalData?.taxType} No. ${data.gstNo}</p>`
          : ""}
            
            <hr style="border-top: 1px dashed #000;"/>
            <p style="font-size: 12px; margin: 0;">${data.warehouseName}</p>
            <p style="font-size: 12px; margin: 0;">${data.warehouseAddress}</p>
            <p style="font-size: 12px; margin: 0;">${data.warehouseNumber}</p>
            <hr style="border-top: 1px dashed #000;"/>
            <div style="display: flex; justify-content: space-between;">
               <span><strong>Challan Number:</strong></span>
               <span>${data.ChallanNumber}</span>
            </div>
            <div style="display: flex; justify-content: space-between;">
              <span><strong>Challan Mode:</strong></span>
              <span>${data.challanMode?.replace(/_/g, " ")}</span>
            </div>
             <div style="display: flex; justify-content: space-between;">
              <span><strong>Date :</strong></span>
              <span>${new Date(challanData.createdDate).toLocaleString(
          "en-GB",
          {
            month: "short",
            day: "2-digit",
            year: "numeric",
            hour12: true,
            hour: "numeric",
            minute: "2-digit",
          }
        )}</span>
            </div>
            <div style="display: flex;">
              <p style="flex: 1; font-weight: bold; margin: 0; text-align: left;">S No.</p>
              <p style="flex: 2; font-weight: bold; margin: 0; text-align: left;">Garment Name</p>
              <p style="flex: 1; font-weight: bold; margin: 0; text-align: right;">Qty</p>
            </div>
            ${garmentSummaryHtml}
             <div style="display: flex; justify-content: space-between;">
              <span><strong>Total:</strong></span>
              <span>${totalQuantity}</span>
            </div>
            <hr style="border-top: 1px dashed #000;"/>
            <p style="font-size: 16px; font-weight: bold;">Powered By ${data.brandName
        }</p>
          </div>
        </body>
      </html>
    `;

      await qz.print(config, [
        { type: "html", format: "plain", data: htmlContent },
      ]);
      // alert("HTML challan sent to printer!");
    } catch (err) {
      console.error("Print failed:", err);
      alert("Failed to print challan");
    }
  };
  const printChallanM2HTML = async () => {
    try {
      const printer = await qz.printers.find(invoicePrinterValue);
      const config = qz.configs.create(printer, {
        encoding: "UTF-8",
        size: { width: 3 },
        units: "in",
        density: "600",
        colorType: "grayscale",
      });

      // Generate the items HTML separately
      const itemsHtml = orderItems2
        .map((orderItem) => {
          const itemList = Object.values(orderItem.itemMap || {});
          const deliveryDate = new Date(
            orderItem.orderDTO.deliveryOn
          ).toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
          });

          return itemList
            .flatMap((obj, idx) => {
              const garmentLines = obj.garmentName
                ?.replace(/_/g, " ")
                .match(/.{1,20}/g) || [""];
              const jobText = obj.serviceName?.replace(/,/g, ", ");
              const jobLines = jobText.match(/.{1,15}/g) || [""];
              const maxLines = Math.max(garmentLines.length, jobLines.length);

              return Array.from({ length: maxLines }, (_, lineIdx) => {
                const showFirstLine = idx === 0 && lineIdx === 0;
                return `
              <div style="display: flex;">
                <p style="flex: 1; font-size: 12px; margin: 0; text-align: left;">${showFirstLine ? orderItem.orderDTO.invoiceNo : ""
                  }</p>
                <p style="flex: 1; font-size: 12px; margin: 0; text-align: left;">${lineIdx === 0 ? obj.itemCount : ""
                  }</p>
                <p style="flex: 2; font-size: 12px; margin: 0; text-align: left;">${garmentLines[lineIdx] || ""
                  }</p>
                <p style="flex: 1; font-size: 12px; margin: 0; text-align: left;">${jobLines[lineIdx] || ""
                  }</p>
                <p style="flex: 1; font-size: 12px; margin: 0; text-align: left;">${showFirstLine ? deliveryDate : ""
                  }</p>
              </div>
            `;
              }).join("");
            })
            .join("");
        })
        .join("");

      // Now complete HTML
      const htmlContent = `
        <html>
          <body style="font-size: 12px; font-family: sans-serif;">
            <div style="text-align: center;">
              <span style="font-size: 18px; font-weight: bold;">Challan</span>
              <hr style="border-top: 1px dashed #000;"/>
              <p style="font-size: 14px; font-weight: bold; margin: 0;">${data.storeName}</p>
              <p style="font-size: 12px; margin: 0;">${data.fullAddress}</p>
              <p style="font-size: 12px; margin: 0;">${data.mobileNumber}</p>
              <p style="font-size: 12px; margin: 0;">${data.email}</p>
              ${
        data.gstNo
          ? `<p style="font-size: 12px; margin: 0;">${storeLocalData?.taxType} No. ${data.gstNo}</p>`
          : ""
                }
              
              <hr style="border-top: 1px dashed #000;"/>
              <p style="font-size: 12px; margin: 0;">${data.warehouseName}</p>
              <p style="font-size: 12px; margin: 0;">${data.warehouseAddress}</p>
              <p style="font-size: 12px; margin: 0;">${data.warehouseNumber}</p>
              <hr style="border-top: 1px dashed #000;"/>
              <div style="display: flex; justify-content: space-between;">
               <span><strong>Challan Number:</strong></span>
               <span>${data.ChallanNumber}</span>
              </div>
              <div style="display: flex; justify-content: space-between;">
               <span><strong>Challan Mode:</strong></span>
               <span>${data.challanMode?.replace(/_/g, " ")}</span>  
              </div>
              <hr style="border-top: 1px dashed #000;"/>
              <div style="display: flex;">
                <p style="flex: 1; font-weight: bold; margin: 0; text-align: left;">Bill No.</p>
                <p style="flex: 1; font-weight: bold; margin: 0; text-align: left;">Pcs</p>
                <p style="flex: 2; font-weight: bold; margin: 0; text-align: left;">Garment</p>
                <p style="flex: 1; font-weight: bold; margin: 0; text-align: left;">Job</p>
                <p style="flex: 1; font-weight: bold; margin: 0; text-align: left;">DD</p>
              </div>
              ${itemsHtml}
              <hr style="border-top: 1px dashed #000;"/>
              <p style="font-size: 16px; font-weight: bold;">Powered By ${data.brandName}</p>
            </div>
          </body>
        </html>
      `;

      await qz.print(config, [
        { type: "html", format: "plain", data: htmlContent },
      ]);
      // alert("HTML challan sent to printer!");
    } catch (err) {
      console.error("Print failed:", err);
      alert("Failed to print challan");
    }
  };
  const printChallanA5HTML = async () => {
    try {
      const printer = await qz.printers.find(normalA5A4PrinterValue);
      const config = qz.configs.create(printer, {
        encoding: "UTF-8",
        size: { width: 5.5 },
        units: "in",
        density: "600",
        colorType: "grayscale",
      });

      // Build the item list in pure HTML
      const itemsHtml = orderItems2
        .map((orderItem) => {
          const itemList = Object.values(orderItem.itemMap || {});
          const deliveryDate = new Date(orderItem.orderDTO.deliveryOn).toLocaleString("en-GB", {
            day: "2-digit",
            month: "2-digit",
          });

          const totalItemCount = itemList.reduce((sum, obj) => sum + (obj.itemCount || 0), 0);

          const particularLines = [
            `<p style="margin: 0; font-weight: bold;">${orderItem.orderDTO.customerName}</p>`,
            ...itemList.map((obj) => {
              const garmentText = obj.garmentName?.replace(/_/g, " ");
              const serviceText = obj.serviceName?.replace(/,/g, ", ");
              return `<p style="margin: 0;">${obj.itemCount} - ${garmentText} - ${serviceText}</p>`;
            }),
          ].join("");

          return `
            <div style="display: flex; width: 100%; margin-bottom: 0px;">
              <div style="flex: 0.4; padding: 2px; border: 1px solid #000;">
                <p style="margin: 0;">${orderItem.orderDTO.invoiceNo}</p>
              </div>
              <div style="flex: 2; padding: 2px; border: 1px solid #000; text-align: left">
                ${particularLines}
              </div>
              <div style="flex: 0.2; padding: 2px; border: 1px solid #000;">
                <p style="margin: 0;">${totalItemCount}</p>
              </div>
              <div style="flex: 0.3; padding: 2px; border: 1px solid #000;">
                <p style="margin: 0;">${deliveryDate}</p>
              </div>
              <div style="width: ${orderItems2.some((item) => item.orderDTO.remarks) ? "200px" : "100px"
            }; padding: 2px; border: 1px solid #000;">
                <p style="margin: 0;">${orderItem.orderDTO.remarks || ""}</p>
              </div>
            </div>
          `;
        })
        .join(""); // Important: join the array to a single HTML string!

      const htmlContent = `
        <html>
          <body style="font-size: 12px; font-family: sans-serif; margin-left:20px; margin-right:20px">
            <div style="text-align: center;">
              <span style="font-size: 18px; font-weight: bold;">Challan</span>
              <hr style="border-top: 1px dashed #000;"/>
              <div style="display: flex;">
                <p style="flex: 1; margin: 0; text-align: left;">${data.storeName}</p>
                <p style="flex: 1; margin: 0; text-align: right;">${data.warehouseName}</p>
              </div>
               <div style="display: flex;">
                <p style="flex: 1; margin: 0; text-align: left;">${data.fullAddress}</p>
                <p style="flex: 1; margin: 0; text-align: right;">${data.warehouseAddress}</p>
              </div>
               <div style="display: flex;">
                <p style="flex: 1; margin: 0; text-align: left;">${data.mobileNumber}</p>
                <p style="flex: 1; margin: 0; text-align: right;">${data.warehouseNumber}</p>
              </div>
               <div style="display: flex;">
                <p style="flex: 1; margin: 0; text-align: left;">${data.email}</p>
                <p style="flex: 1; margin: 0; text-align: right;"></p>
              </div>
              <div style="display: flex;">
                <p style="flex: 1; margin: 0; text-align: left;">${storeLocalData?.taxType} No. ${data.gstNo}</p>
                <p style="flex: 1; margin: 0; text-align: right;"></p>
              </div>
               ${
        data.gstNo
          ? `<p style="font-size: 12px; margin: 0;">${storeLocalData?.taxType} No. ${data.gstNo}</p>`
          : ""
                }
              <hr style="border-top: 1px dashed #000;"/>
              <div style="display: flex; justify-content: space-between; font-size: 12px;">
                <span><strong>Challan Number:</strong></span>
                <span><strong>${data.ChallanNumber}</strong></span>
              </div>
              <div style="display: flex; justify-content: space-between; font-size: 12px;">
                <span><strong>Challan Mode:</strong></span>
                <span>${data.challanMode?.replace(/_/g, " ")}</span>
              </div>
              <div style="display: flex; font-weight: bold; margin-top: 8px;">
                <p style="flex: 0.4; margin: 0; text-align: left;">Bill No.</p>
                <p style="flex: 2; margin: 0; text-align: left;">Particular</p>
                <p style="flex: 0.2; margin: 0; text-align: left;">Pcs</p>
                <p style="flex: 0.3; margin: 0; text-align: left;">DD</p>
                <p style="width: ${orderItems2.some((item) => item.orderDTO.remarks) ? "200px" : "100px"}; margin: 0; text-align: left;">Remarks</p>
              </div>
  
              ${itemsHtml}
  
              <hr style="border-top: 1px dashed #000; margin-top: 8px;"/>
              <p style="font-size: 16px; font-weight: bold;">Powered By ${data.brandName}</p>
            </div>
          </body>
        </html>
      `;

      await qz.print(config, [
        { type: "html", format: "plain", data: htmlContent },
      ]);
      // alert("HTML challan sent to printer!");
    } catch (err) {
      console.error("Print failed:", err);
      alert("Failed to print challan");
    }
  };


  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/WarehouseChallanList")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">Challan</p>
            </div>
            {!storePOSEnabledValue && <div className="flex justify-content-center align-items-center cursor-pointer">
              <Button
                label="A5"
                onClick={() => handleEWHChallanViewChange("a5")}
                className=" text-lg w-full border-round-lg p-1 mx-2 cursor-pointer"
                style={{
                  color: storeChallanView === "a5" ? "#fff" : "#2B70D7",
                  backgroundColor: storeChallanView === "a5" ? "red" : "#fff",
                  borderColor: "#2B70D7",
                }}
              ></Button>
            </div>}
            {!storePOSEnabledValue && <div className="flex justify-content-center align-items-center cursor-pointer">
              <Button
                label="M2"
                onClick={() => handleEWHChallanViewChange("m2")}
                className=" text-lg w-full border-round-lg p-1 mx-2 cursor-pointer"
                style={{
                  color: storeChallanView === "m2" ? "#fff" : "#2B70D7",
                  backgroundColor: storeChallanView === "m2" ? "red" : "#fff",
                  borderColor: "#2B70D7",
                }}
              ></Button>
            </div>}
            {!storePOSEnabledValue && <div className="flex justify-content-center align-items-center cursor-pointer">
              <Button
                label="M1"
                onClick={() => handleEWHChallanViewChange("m1")}
                className=" text-lg w-full border-round-lg p-1 mx-2 cursor-pointer"
                style={{
                  color: storeChallanView === "m1" ? "#fff" : "#2B70D7",
                  backgroundColor: storeChallanView === "m1" ? "red" : "#fff",
                  borderColor: "#2B70D7",
                }}
              ></Button>
            </div>}
            {!storePOSEnabledValue && <div className="flex">
              <div
                className="mx-4 cursor-pointer"
                onClick={
                  storeChallanView === "m1"
                    ? printChallanM1HTML
                    : storeChallanView === "m2"
                      ? printChallanM2HTML
                      : printChallanA5HTML
                }
              >
                <img
                  src={"images/printer.png"}
                  style={{
                    width: 35,
                  }}
                />
              </div>
            </div>}

            {storePOSEnabledValue && invoicePrinterPOSValue && (
                                  <div className="flex justify-content-center align-items-center cursor-pointer">
                                      <Button
                                        label="POS Print"
                                        onClick={() => printPOSImage()}
                                        className=" text-lg w-full border-round-lg p-1 mx-2 cursor-pointer"
                                        style={{
                                          color: "#2B70D7",
                                          backgroundColor: "#fff",
                                          borderColor: "#2B70D7",
                                        }}
                                      ></Button>
                                    </div>
                                  )}
          </div>
        </div>
      </div>

      {storeChallanView === "m2" ? (
        <div className="flex justify-content-between mt-2">
          <div></div>
          <div className="w-5 ">
            <div className="flex justify-content-center flex-column print-section">
              <p className="text-2xl font-medium text-center line-height-2">
                Challan
              </p>
              <div className="flex justify-content-center align-items-center py-1">
                <p className="w-7  border-dashed border-1 "></p>
              </div>
              <p className="text-lg font-medium text-center line-height-2">
                {data.storeName}
              </p>
              <p className="text-md font-normal text-center line-height-2">
                {data.fullAddress}
              </p>
              <p className="text-md font-normal text-center line-height-2">
                {data.mobileNumber}
              </p>
              <p className="text-md font-normal text-center">{data.email}</p>
              {data.gstNo && <p className="text-md font-normal text-center">{storeLocalData?.taxType} No. {data.gstNo}</p>}
              <div className="flex justify-content-center align-items-center  py-1">
                <p className="w-5  border-dashed border-1 "></p>
              </div>

              <p className="text-lg font-medium text-center line-height-2">
                {data.warehouseName}
              </p>
              <p className="text-md font-normal text-center line-height-2">
                {data.warehouseAddress}
              </p>
              <p className="text-md font-normal text-center line-height-2">
                {data.warehouseNumber}
              </p>
              <div className="flex justify-content-center align-items-center  py-1">
                <p className="w-5  border-dashed border-1 "></p>
              </div>

              <div className="flex justify-content-center gap-1">
                <p className="text-md font-medium text-right line-height-2"></p>
              </div>
              <div className="flex justify-content-between gap-5">
                <p className="text-md font-medium text-left line-height-2">
                  Challan Number
                </p>
                <p className="text-md font-normal text-right line-height-2">
                  {data.ChallanNumber}
                </p>
              </div>
              <div className="flex justify-content-between gap-5">
                <p className="text-md font-medium text-left line-height-2">
                  Challan Mode
                </p>
                <p className="text-md font-normal text-right line-height-2">
                  {data.challanMode?.replace(/_/g, " ")}
                </p>
              </div>

              {challanData.createdDate && (
                <React.Fragment>
                  <div className="flex justify-content-between gap-5">
                    <p className="text-md font-medium text-left line-height-2">
                      Date:
                    </p>
                    <p className="text-md font-normal text-right line-height-2">
                      {new Date(challanData.createdDate).toLocaleString(
                        "en-GB",
                        {
                          month: "short",
                          day: "2-digit",
                          year: "numeric",
                          hour12: true,
                          hour: "numeric",
                          minute: "2-digit",
                        }
                      )}
                    </p>
                  </div>
                </React.Fragment>
              )}

              <p className="text-md font-medium text-center">
                {data.customerMobile}
              </p>
              <div className="flex justify-content-center align-items-center mb-4  py-1">
                <p className="w-5  border-dashed border-1 "></p>
              </div>
              <div className="flex">
                <p
                  className="text-sm font-medium text-left line-height-1"
                  style={{ flex: 0.7 }}
                >
                  Bill No.:
                </p>
                <p
                  className="text-sm font-normal text-left line-height-1"
                  style={{ flex: 0.1 }}
                ></p>
                <p
                  className="text-sm font-medium text-left line-height-1"
                  style={{ flex: 0.5 }}
                >
                  Pcs
                </p>
                <p
                  className="text-sm font-medium text-left line-height-1"
                  style={{ flex: 2 }}
                >
                  Garment
                </p>
                <p
                  className="text-sm font-normal text-left line-height-1"
                  style={{ flex: 0.1 }}
                ></p>
                <p
                  className="text-sm font-medium text-left line-height-1"
                  style={{ flex: 0.5 }}
                >
                  Job
                </p>
                <p
                  className=" text-sm font-medium text-right line-height-1"
                  style={{ flex: 0.7 }}
                >
                  DD
                </p>
              </div>
              {orderItems2.map((orderItem, orderIdx) => {
                const itemList = Object.values(orderItem.itemMap || {});
                const deliveryDate = new Date(
                  orderItem.orderDTO.deliveryOn
                ).toLocaleString("en-GB", {
                  day: "2-digit",
                  month: "2-digit",
                });

                return itemList.flatMap((obj, idx) => {
                  // Split long texts for wrapping
                  const garmentLines = obj.garmentName
                    ?.replace(/_/g, " ")
                    .match(/.{1,20}/g) || [""];
                  const jobText = obj.serviceName?.replace(/,/g, ", ");
                  const jobLines = jobText.match(/.{1,15}/g) || [""];
                  const maxLines = Math.max(
                    garmentLines.length,
                    jobLines.length
                  );

                  return [...Array(maxLines)].map((_, lineIdx) => {
                    const showFirstLine = idx === 0 && lineIdx === 0;
                    return (
                      <div
                        className="flex "
                        key={`${orderIdx}-${idx}-${lineIdx}`}
                      >
                        <p
                          className="text-sm font-normal text-left line-height-1"
                          style={{ flex: 0.7 }}
                        >
                          {showFirstLine ? orderItem.orderDTO.invoiceNo : " "}
                        </p>
                        <p
                          className="text-sm font-normal text-left line-height-1"
                          style={{ flex: 0.1 }}
                        ></p>
                        <p
                          className="text-sm font-normal text-left line-height-1"
                          style={{ flex: 0.5 }}
                        >
                          {lineIdx === 0 ? obj.itemCount : " "}
                        </p>
                        <p
                          className="text-sm font-normal text-left line-height-1"
                          style={{ flex: 2 }}
                        >
                          {garmentLines[lineIdx] || " "}
                        </p>
                        <p
                          className="text-sm font-normal text-left line-height-1"
                          style={{ flex: 0.1 }}
                        ></p>

                        <p
                          className=" text-sm font-normal text-left line-height-1"
                          style={{ flex: 0.5 }}
                        >
                          {jobLines[lineIdx] || " "}
                        </p>
                        <p
                          className="text-sm font-normal text-right line-height-1"
                          style={{ flex: 0.7 }}
                        >
                          {showFirstLine ? deliveryDate : " "}
                        </p>
                      </div>
                    );
                  });
                });
              })}

              <div className="flex justify-content-center align-items-center  py-1">
                <p className="w-7  border-dashed border-1 "></p>
              </div>
              <p className="text-2xl font-medium text-center">
                Powered By {data.brandName}
              </p>
            </div>
          </div>

          {storePOSEnabledValue ? <div className="ml-4 cursor-pointer" onClick={() => window.print()}>
            <img
              src={"Icons/printer.png"}
              style={{
                width: 0,
              }}
            />
          </div> :
            <div className="ml-4 cursor-pointer" onClick={() => window.print()}>
              <img
                src={"Icons/printer.png"}
                style={{
                  width: 65,
                }}
              />
            </div>}
        </div>
      ) : storeChallanView === "m1" ?
        <div className="flex justify-content-between mt-2">
          <div></div>
          <div className="w-5 ">
            <div className="flex justify-content-center flex-column print-section">
              <p className="text-2xl font-medium text-center">Challan</p>
              <div className="flex justify-content-center align-items-center">
                <p className="w-7  border-dashed border-1 "></p>
              </div>
              <p className="text-lg font-medium text-center">{data.brandName}</p>
              <div className="flex justify-content-center align-items-center">
                <p className="w-5  border-dashed border-1 "></p>
              </div>
              <p className="text-lg font-medium text-center">
                {data.warehouseName}
              </p>
              <p className="text-md font-normal text-center">
                {data.warehouseAddress}
              </p>
              <p className="text-md font-normal text-center">
                {data.warehouseNumber}
              </p>
              <div className="flex justify-content-center align-items-center">
                <p className="w-5  border-dashed border-1 "></p>
              </div>
              <p className="text-lg font-medium text-center">
                {data.storeName}
              </p>
              <p className="text-md font-normal text-center">
                {data.fullAddress}
              </p>
              <p className="text-md font-normal text-center">
                {data.mobileNumber}
              </p> <p className="text-md font-normal text-center">
                {data.email}
              </p>
              {data.gstNo &&<p className="text-md font-normal text-center">
                  {storeLocalData?.taxType} No. {data.gstNo}
              </p>}
              <div className="flex justify-content-center align-items-center">
                <p className="w-5  border-dashed border-1 "></p>
              </div>
              <div className="flex justify-content-center gap-1">
                <p className="text-md font-medium text-left">Challan Number</p>
              </div>
              <div className="flex justify-content-center gap-1">
                <p className="text-md font-medium text-left">
                  {data.ChallanNumber}
                </p>
              </div>
              <div className="flex justify-content-center align-items-center">
                <p className="w-5  border-dashed border-1 "></p>
              </div>
              <div className="flex justify-content-between gap-5">
                <p className="text-md font-medium text-left">Challan Mode:</p>
                <p className="text-md font-normal text-right">
                  {data.challanMode?.replace(/_/g, " ")}
                </p>
              </div>
              <div className="flex justify-content-between gap-5">
                <p className="text-md font-medium text-left">Date:</p>
                <p className="text-md font-normal text-right">{data.date}</p>
              </div>

              <div className="flex justify-content-center align-items-center">
                <p className="w-5  border-dashed border-1 "></p>
              </div>
              <div className="flex">
                <p className="text-md font-medium text-left" style={{ flex: 1 }}>
                  S. No.
                </p>
                <p className="text-md font-medium text-left" style={{ flex: 2 }}>
                  Garment Name
                </p>
                <p className="flex-1 text-md font-medium text-right">Qty</p>
              </div>

              {garmentSummary.map((item, index) => (
                <div className="flex" key={index + 1}>
                  <p className="text-md" style={{ flex: 1 }}>
                    {index + 1}
                  </p>
                  <p className="text-md" style={{ flex: 2 }}>
                    {item.garmentName}
                  </p>
                  <p className="text-md text-right" style={{ flex: 1 }}>
                    {item.count}
                  </p>
                </div>
              ))}
              <div className="flex justify-content-between gap-5">
                <p className="text-md font-medium text-left">Total:</p>
                <p className="text-md font-normal text-right">{totalQuantity}</p>
              </div>

              <div className="flex justify-content-center align-items-center">
                <p className="w-7  border-dashed border-1 "></p>
              </div>
              <p className="text-2xl font-medium text-center">
                Powered By {data.brandName}
              </p>
            </div>
          </div>

            {storePOSEnabledValue ? <div className="ml-4 cursor-pointer" onClick={() => window.print()}>
              <img
                src={"Icons/printer.png"}
                style={{
                  width: 0,
                }}
              />
            </div> :
              <div className="ml-4 cursor-pointer" onClick={() => window.print()}>
                <img
                  src={"Icons/printer.png"}
                  style={{
                    width: 65,
                  }}
                />
              </div>}
        </div>
        : (
          <div className="flex justify-content-between mt-2">
            <div></div>
            <div className="w-8 ">
              <div className="flex justify-content-center flex-column print-section">
                <p className="text-2xl font-medium text-center">Challan</p>
                <div className="flex justify-content-center align-items-center">
                  <p className="w-7  border-dashed border-1 "></p>
                </div>
                <div className="flex justify-content-between gap-5">
                  <p className="text-md font-medium text-left">
                    {data.storeName}
                  </p>
                  <p className="text-md font-medium text-right">
                    {data.warehouseName}
                  </p>
                </div>
                <div className="flex justify-content-between gap-5">
                  <p className="text-md font-medium text-left">
                    {data.fullAddress}
                  </p>

                  <p className="text-md font-medium text-right">
                    {data.warehouseAddress}
                  </p>
                </div>
                <div className="flex justify-content-between gap-5">
                  <p className="text-md font-medium text-left">
                    {data.mobileNumber}
                  </p>

                  <p className="text-md font-medium text-right">
                    {data.warehouseNumber}
                  </p>
                </div>
                <div className="flex justify-content-between gap-5">
                  <p className="text-md font-medium text-left">{data.email}</p>
                  <p className="text-md font-medium text-right">

                  </p>
                </div>

                  {data.gstNo && <div className="flex justify-content-between gap-5">
                    <p className="text-md font-medium text-left">{storeLocalData?.taxType} No. {data.gstNo}</p>
                  <p className="text-md font-medium text-right">

                  </p>
                </div>}

                <div className="flex justify-content-between gap-5">
                  <p className="text-md font-medium text-left">Challan Number</p>
                  <p className="text-md font-medium text-right">
                    {data.ChallanNumber}
                  </p>
                </div>
                <div className="flex justify-content-between gap-5">
                  <p className="text-md font-medium text-left">Challan Mode</p>
                  <p className="text-md font-medium text-right">
                    {data.challanMode?.replace(/_/g, " ")}
                  </p>
                </div>

                <div className="flex justify-content-between gap-5">
                  <p className="text-md font-medium text-left">Created Date:</p>
                  <p className="text-md font-medium text-right">
                    {new Date(challanData.createdDate).toLocaleString("en-GB", {
                      month: "short",
                      day: "2-digit",
                      year: "numeric",
                      hour12: true,
                      hour: "numeric",
                      minute: "2-digit",
                    })}
                  </p>
                </div>

                <p className="text-lg font-medium text-center">
                  {data.customerMobile}
                </p>
                <div className="flex justify-content-center align-items-center mb-4">
                  <p className="w-5  border-dashed border-1 "></p>
                </div>
                <div className="flex ">
                  <p
                    className="text-md font-semibold text-left border-1 px-2 line-height-1"
                    style={{ flex: 0.4 }}
                  >
                    Bill No.:
                  </p>
                  <p
                    className="text-md font-semibold text-left border-1 px-2 line-height-1"
                    style={{ flex: 2 }}
                  >
                    Garment
                  </p>
                  <p
                    className="text-md font-semibold text-left border-1 px-2 line-height-1"
                    style={{ flex: 0.2 }}
                  >
                    Pcs
                  </p>
                  <p
                    className="text-md font-semibold text-left border-1 px-2 line-height-1"
                    style={{ flex: 0.3 }}
                  >
                    DD
                  </p>
                  <p
                    className="text-md font-semibold text-left border-1 px-2 line-height-1"
                    style={{
                      width: orderItems2.some((item) => item.orderDTO.remarks)
                        ? "200px"
                        : "100px",
                    }}
                  >
                    Remarks
                  </p>
                </div>

                {orderItems2.map((orderItem, orderIdx) => {
                  const itemList = Object.values(orderItem.itemMap || {});
                  const deliveryDate = new Date(
                    orderItem.orderDTO.deliveryOn
                  ).toLocaleString("en-GB", {
                    day: "2-digit",
                    month: "2-digit",
                  });

                  const totalItemCount = itemList.reduce(
                    (sum, obj) => sum + (obj.itemCount || 0),
                    0
                  );

                  // Build particular lines: 1st line is customer, then garments
                  const particularLines = [
                    orderItem.orderDTO.customerName,
                    ...itemList.flatMap((obj) => {
                      const garmentText = obj.garmentName?.replace(/_/g, " ");
                      const serviceText = obj.serviceName?.replace(/,/g, ", ");
                      return [
                        `${obj.itemCount} - ${garmentText} - ${serviceText}`,
                      ];
                    }),
                  ];

                  return (
                    <div className="flex w-full" key={orderIdx}>
                      {/* Left side: Bill No., Pcs, DD */}
                      <div
                        className="flex flex-col items-start border-1 px-2"
                        style={{ flex: 0.4, justifyContent: "flex-start" }}
                      >
                        <p className="text-md font-normal line-height-1">
                          {orderItem.orderDTO.invoiceNo}
                        </p>
                      </div>

                      {/* Middle column: Particular (with multiple lines) */}
                      <div
                        className="flex flex-col border-1 px-2"
                        style={{ flex: 2, flexDirection: "column" }}
                      >
                        {particularLines.map((line, i) => (
                          <p
                            key={i}
                            className={`text-md text-left line-height-1 ${i === 0 ? "font-bold" : "font-normal"
                              }`}
                          >
                            {line}
                          </p>
                        ))}
                      </div>
                      <div
                        className="flex flex-col items-start border-1 px-2"
                        style={{ flex: 0.2 }}
                      >
                        <p className="text-md font-normal line-height-1">
                          {totalItemCount}
                        </p>
                      </div>
                      {/* Right side: Delivery Date */}
                      <div
                        className="flex flex-col items-start border-1 px-2"
                        style={{ flex: 0.3 }}
                      >
                        <p className="text-md font-normal line-height-1">
                          {deliveryDate}
                        </p>
                      </div>
                      <div
                        className="flex flex-col items-start border-1 px-2"
                        style={{
                          width: orderItems2.some((item) => item.orderDTO.remarks)
                            ? "200px"
                            : "100px",
                        }}
                      >
                        <p className="text-md font-normal line-height-1">
                          {orderItem.orderDTO.remarks}
                        </p>
                      </div>
                    </div>
                  );
                })}

                <p className="text-2xl font-medium text-center">
                  Powered By {data.brandName}
                </p>
              </div>
            </div>

              {storePOSEnabledValue ? <div className="ml-4 cursor-pointer" onClick={() => window.print()}>
                <img
                  src={"Icons/printer.png"}
                  style={{
                    width: 0,
                  }}
                />
              </div> :
                <div className="ml-4 cursor-pointer" onClick={() => window.print()}>
                  <img
                    src={"Icons/printer.png"}
                    style={{
                      width: 65,
                    }}
                  />
                </div>}
          </div>
        )}

      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .print-section, .print-section * {
              visibility: visible;
            }
            .print-section {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              page-break-after: always;
            }
                      @page {
              size: 80mm auto;
              margin: 2mm;
            }
          }
        `}
      </style>
    </div>
  );
};

export default WarehouseChallanReceipt;
